<template>
  <div class="px-10">
    <app-pagination
      ref="pag"
      :getter="getStudents"
      :params="{ limit: 10, teachers__uuid: teacher.uuid }"
      table
      dense
      header
      :tableHeader="headers"
      @edit="$emit('edit', $event)"
      @remove="onRemove"
    >
      <template #header>
        <v-btn
          text
          color="#29284c"
          height="40"
          width="200"
          class="comment__div text-capitalize"
          @click="dialog = true"
        >
          <v-icon>mdi-magnify</v-icon>New Student
        </v-btn>
      </template>
    </app-pagination>
    <app-students-dialog v-model="dialog" :action="action" disable>
      <template #buttonText>Add</template>
    </app-students-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import StudentsDialog from "@/components/StudentsDialog.vue";

import { getStudents, patchTeacher } from "@/api/api";

export default {
  components: {
    appPagination: Pagination,
    appStudentsDialog: StudentsDialog,
  },
  data() {
    return {
      getStudents,
      headers: [
        { text: "Picture", value: "avatar" },
        { text: "Remove", value: "remove", align: "center" },
        { text: "Name", value: "fullName" },
        { text: "Email", value: "email" },
      ],
      dialog: false,
    };
  },
  computed: {
    teacher: {
      get() {
        return this.$store.getters["admin/teacher"];
      },
      set(value) {
        this.$store.commit("admin/teacher", value);
      },
    },
  },
  methods: {
    async onRemove(e) {
      try {
        const students = this.teacher.students;
        students.splice(students.indexOf(e.email), 1);
        const response = await patchTeacher({
          uuid: this.teacher.uuid,
          body: {
            students,
          },
        });
        this.teacher = response.data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.$refs.pag.removeResult(e);
    },
    async action(e) {
      try {
        const response = await patchTeacher({
          uuid: this.teacher.uuid,
          body: {
            students: [e.email, ...this.teacher.students],
          },
        });
        this.teacher = response.data;
        this.$refs.pag.addResult(e);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.comment__div {
  border: dashed #29284c 2px;
  border-radius: 10px;
}
</style>
